import React, { useEffect, useState } from 'react';
import { usePosting, useTitle } from '../../Hooks';
import { PostingInvite, SetLoading } from '../../Classes';
import { useParams } from 'react-router-dom';
import { Button, Header, Placeholder, Table, Stat, Toast } from 'react-frontier';
import { Card, Modal } from '../../components';
import { bindClick } from '@tempu/components/Util';
import { firstBy } from 'thenby';
import API, { CDN_URL } from '../../API';
import BusinessAccess from '../../BusinessAccess';
import moment from 'moment';

var PostingInvitations= ()=>{
   var params = useParams<{ pid: string }>();
   var posting_id = parseInt(params?.pid);
	var { hasAccess } = usePosting(posting_id);
   var { setTitle } = useTitle();
   var [loadError, setLoadError] = useState<string>(null);
   var [users, setUsers] = useState<PostingInvite[]>(null);
	var [selectedUser, setSelectedUser] = useState<PostingInvite>(null);
	var [modalPrompts, setModalPrompts] = useState<string[]>(null);
   var [invitationModal, setInvitationModal] = useState<boolean>(false);

	useEffect(()=>{
		setTitle('Aplicantes');
      if(!params || !posting_id || Number.isNaN(posting_id)) return;
		if(!hasAccess(BusinessAccess.USERS.APPROVE_USERS)) return;

		API.getPostingInvites(posting_id).then(res=>{
			if(res.error) setLoadError(res.message);
			setUsers(res.data);
		}).catch(err=>{
			setLoadError('Hubo un error cargando la lista de invitaciónes (LCL-1)');
		})
	}, []);

	var openInvitationModal = (user: PostingInvite)=>{
		setSelectedUser(user);
		setInvitationModal(true);
	};

   var resendInvitation = (setLoading: SetLoading) => {
		if(!selectedUser) return setModalPrompts(['Debes seleccionar un aplicante.']);
		setLoading(true);
		API.resendUserInvitation(selectedUser.job_id, selectedUser.user_id).then(res => {
			if(res.error) return setModalPrompts([res.message]);
			Toast.success('Invitación enviada!');
         setInvitationModal(null);
		}).catch(() => {
			setModalPrompts(['Hubo un error al aprobar el aplicante. (RUI-1)']);
		}).finally(() => {
			setLoading(false);
		});
	};

	if(!hasAccess(BusinessAccess.USERS.APPROVE_USERS)){
		return <Header text='Sin acceso' subtext='No tienes acceso a esta página' />
	}
	
	return <div className="tp posting-applicants-screen">
		<div className="fr stats block">
			<Stat label={'Invitados'} value={users ? (
				users.length
			) : (
				<Placeholder width={40} height={30} />
			)} />
		</div>
		{loadError ? (
			<Header text='Error' subtext={loadError} />
		) : users ? (
			Object.entries(
				users
					.sort(firstBy('job_id', 'asc').thenBy('rejected', 'asc').thenBy('date_created', 'asc'))
					.reduce((i, user) => { (i[user.job_name] ||= []).push(user); return i }, {} as Record<string, typeof users>)
			).map(([jobName, groupedUsers]) => (
				<React.Fragment key={`JOB-${jobName}`}>
					<Header text={jobName} centered={false} style={{ marginTop: 15 }} size='small' />
					{groupedUsers.map(a => (
						<Card
							className='applicant'
							image={a.image}
							imageFallbackIcon='image'
							key={`PSTATS-${a.user_id}`}
							onClick={() => openInvitationModal(a)}
						>
							<div className="left">
								<div className="name">{a.first_name} {a.last_name}</div>
								<div className="job-name">{a.job_name}</div>
								<div className="meta">Invitado: {moment.unix(a.date_created).format('DD/MMM/YY HH:mm')}</div>
							</div>
						</Card>
					))}
				</React.Fragment>
			))
		) : (
			Array.from({ length: 3 }).map((_, i) => (
				<Card placeholder placeholderImage className='applicant' key={`CRDPLH-${i}`}>
					<div className="left">
						<Placeholder height={24} width={200} />
						<Placeholder width={50} />
						<Placeholder width={50} />
					</div>
				</Card>
			))
		)}
		{users && users.length === 0 && (
			<Header text={'Sin invitaciónes'} subtext={'Este empleo no tiene invitaciónes pendientes'} iconName='user-plus' />
		)}
		<Modal open={invitationModal} onClose={bindClick(setInvitationModal)} size='tiny'>
			<Modal.Header>Información de aplicante</Modal.Header>
			{selectedUser && (
				<Modal.Content>
					<Table details striped fitted>
                  <Table.Row data={['Nombre', `${selectedUser.first_name} ${selectedUser.last_name}`]} />
                  <Table.Row data={['Puesto', selectedUser.job_name]} />
                  <Table.Row data={['Correo electrónico', selectedUser.email]} />
                  <Table.Row data={['Teléfono', selectedUser.phone]} />
                  <Table.Row data={['Invitado', moment.unix(selectedUser.date_created).format('DD/MMM/YY HH:mm')]} />
					</Table>
               <div style={{ textAlign: 'center', padding: 20 }}>
                  <Button text='Reenviar invitación' color='black' basic onClick={resendInvitation}/>
               </div>
				</Modal.Content>
			)}
			<Modal.Actions>
				<Button text='Cerrar' onClick={bindClick(setInvitationModal)} />
			</Modal.Actions>
		</Modal>
	</div>
}

export default PostingInvitations;